class annoucementCountdownTimer extends HTMLElement {
  constructor() {
    super();

    this.endToday = this.getAttribute("data-end-today") === "true";
    this.endDate = this.getAttribute("data-section_timer");

    if (this.endToday) {
      this.startDailyResetCountdownCET();
    } else if (this.endDate) {
      this.manageCountdown(this.endDate);
    }
  }

  /**
   * DAILY RESET — CET MIDNIGHT
   */
  startDailyResetCountdownCET() {

    console.log('hiiii');

    const getCETMidnightTimestamp = () => {

      const now = new Date();

      // 1️⃣ Get CET components EXACTLY (no string-to-Date conversion)
      const parts = new Intl.DateTimeFormat("en-GB", {
        timeZone: "Europe/Berlin",
        hour12: false,
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric"
      }).formatToParts(now);

      const get = type => parseInt(parts.find(p => p.type === type).value);

      const cetYear   = get("year");
      const cetMonth  = get("month") - 1; // JS months 0-11
      const cetDay    = get("day");
      const cetHour   = get("hour");
      const cetMinute = get("minute");
      const cetSecond = get("second");

      // 2️⃣ Build a UTC version of the CET current time
      // This produces the accurate CET offset in milliseconds
      const utcContainer = Date.UTC(
        cetYear,
        cetMonth,
        cetDay,
        cetHour,
        cetMinute,
        cetSecond
      );

      // Current UTC timestamp
      const nowUTC = now.getTime();

      // CET offset = (CET wall-clock interpreted as UTC) - actual UTC
      const cetOffsetMs = utcContainer - nowUTC;

      // 3️⃣ Build CET midnight in wall-clock CET time
      const cetMidnightUTC = Date.UTC(
        cetYear,
        cetMonth,
        cetDay + 1, 
        0, 0, 0
      );

      // 4️⃣ Convert CET midnight → ACTUAL UTC timestamp
      return cetMidnightUTC - cetOffsetMs;
    };

    let endTimestamp = getCETMidnightTimestamp();

    setInterval(() => {
      const now = Date.now();
      let diff = endTimestamp - now;

      // If CET midnight passed → reset for next day
      if (diff <= 0) {
        endTimestamp = getCETMidnightTimestamp();
        diff = endTimestamp - now;
      }

      this.updateUI(diff);
    }, 1000);
  }


  /**
   * FIXED DATE COUNTDOWN
   */
  manageCountdown(endDate) {
    const endDateMilliseconds = new Date(endDate).getTime();

    if (isNaN(endDateMilliseconds)) {
      console.error("Invalid countdown date:", endDate);
      return;
    }

    const timer = setInterval(() => {
      const now = Date.now();
      const diff = endDateMilliseconds - now;

      if (diff <= 0) {
        this.classList.add("d-none");
        clearInterval(timer);
        return;
      }

      this.updateUI(diff);
    }, 1000);
  }

  /**
   * UPDATE UI
   */
  updateUI(diff) {
    const totalHours = Math.floor(diff / 3600000);
    const minutes = Math.floor((diff % 3600000) / 60000);
    const seconds = Math.floor((diff % 60000) / 1000);

    const hourStr = totalHours.toString().padStart(2, "0").split('');
    const minStr = minutes.toString().padStart(2, "0").split('');
    const secStr = seconds.toString().padStart(2, "0").split('');

    const q = (sel) => this.querySelector(sel);

    // HOURS
    if (q('[data-hour_1]')) q('[data-hour_1]').textContent = hourStr[0] || "";
    if (q('[data-hour_2]')) q('[data-hour_2]').textContent = hourStr[1] || "";
    if (q('[data-hour_3]')) q('[data-hour_3]').textContent = hourStr[2] || "";

    // MINUTES
    if (q('[data-min_1]')) q('[data-min_1]').textContent = minStr[0];
    if (q('[data-min_2]')) q('[data-min_2]').textContent = minStr[1];

    // SECONDS
    if (q('[data-sec_1]')) q('[data-sec_1]').textContent = secStr[0];
    if (q('[data-sec_2]')) q('[data-sec_2]').textContent = secStr[1];
  }
}

customElements.define("annoucement-countdown-time", annoucementCountdownTimer);
